import { styled } from "@mui/material";
//import dayjs from "dayjs";
import {
  DatePicker as MuiDatePicker,
  DatePickerProps as MuiDatePickerProps,
} from "@mui/x-date-pickers/DatePicker";

export interface DatePickerProps extends MuiDatePickerProps<any> {}

const StyledDatePicker = styled(MuiDatePicker)(({ theme }) => {
  return {
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[300],
    },
  };
});

export const DatePicker: React.FC<DatePickerProps> = ({ ...props }) => {
  return <StyledDatePicker {...props} />;
};

export default DatePicker;
